import { render, staticRenderFns } from "./ChatImage.vue?vue&type=template&id=4cf59b6c&"
import script from "./ChatImage.vue?vue&type=script&lang=js&"
export * from "./ChatImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports